import { assembleExploreViewModel, resolveFetchWindow } from "@/analytics/data/assemble-explore";
import { fetchAnalyticsRawData } from "@/analytics/data/fetch-analytics-data";
import type { ExploreParams } from "@/analytics/dashboards/explore/hooks/useExploreParams";
import type { CompareWindow, PeriodWindow } from "@/analytics/core/types";
import { getDepartment } from "@/grid/config/registry";
import type { ExploreViewModel } from "@/analytics/core/types";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export function useExploreData(
  departmentId: string,
  params: ExploreParams,
  period: PeriodWindow,
  compare: CompareWindow,
) {
  const department = getDepartment(departmentId);

  return useQuery({
    queryKey: ["explore", departmentId, params, period, compare],
    queryFn: async (): Promise<ExploreViewModel> => {
      if (!department) throw new Error(`Unknown department: ${departmentId}`);

      const fetchWindow = resolveFetchWindow(period, compare);
      const raw = await fetchAnalyticsRawData(department, fetchWindow);

      return assembleExploreViewModel(department, raw, {
        selection: params.selection,
        period,
        compare,
        metricId: params.metricId,
      });
    },
    enabled: Boolean(department),
    staleTime: 5 * 60_000,
    placeholderData: keepPreviousData,
  });
}
